var _defs, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-2 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-3 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-4 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 37.5,
    cy: 37.5,
    r: 29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m22.46,40.01l6.65,6.65c1.17,1.17,3.07,1.17,4.24,0l19.19-19.19"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(0 -5.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Tic"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 12.19,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.78,
    y: 0,
    xmlSpace: "preserve"
  }, " - O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 32.12,
    y: 0
  }, "ff"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickOff);
export default __webpack_public_path__ + "static/media/__Tick Off.546d00f006dc6b7d1bed26287983ce97.svg";
export { ForwardRef as ReactComponent };